import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import NightlightRoundedIcon from '@mui/icons-material/NightlightRounded';
import NightlightOutlinedIcon from '@mui/icons-material/NightlightOutlined';
import DeviceThermostatOutlinedIcon from '@mui/icons-material/DeviceThermostatOutlined';
import ThermostatRoundedIcon from '@mui/icons-material/ThermostatRounded';
import OpacityRoundedIcon from '@mui/icons-material/OpacityRounded';
import AirRoundedIcon from '@mui/icons-material/AirRounded';
import WbCloudyRoundedIcon from '@mui/icons-material/WbCloudyRounded';
import GrainRoundedIcon from '@mui/icons-material/GrainRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import { useTheme } from '@mui/material/styles';

export default function WeatherDailyTable(props) {
  const theme = useTheme()

  const mode = theme.palette.mode
  
  const weather = props.weather
  const min = props.min

  return (
    <div>
      {/* {weather.weather[0].main} */}
      <table className={mode == 'dark' ? 'table table-striped table-dark' : 'table table-striped'}>
        <thead>
          <tr>
            <th>Parametro</th>
            <th>Valore</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>descrizione</td>
            <td>{weather.weather[0].description}</td>
          </tr>
          <tr>
            <td>Ora alba</td>
            <td><LightModeOutlinedIcon />{getTimeHours(weather.sunrise)}</td>
          </tr>
          <tr>
            <td>Ora tramonto</td>
            <td><LightModeRoundedIcon />{getTimeHours(weather.sunset)}</td>
          </tr>
          <tr>
            <td>Ora alba lunare</td>
            <td><NightlightRoundedIcon />{getTimeHours(weather.moonrise)}</td>
          </tr>
          <tr>
            <td>Ora tramonto lunare</td>
            <td><NightlightOutlinedIcon />{getTimeHours(weather.moonset)}</td>
          </tr>
          <tr>
            <td>temperatura minima</td>
            <td><DeviceThermostatOutlinedIcon />{weather.temp.min}°C</td>
          </tr>
          <tr>
            <td>temperatura massima</td>
            <td><ThermostatRoundedIcon />{weather.temp.max}°C</td>
          </tr>
          {
            min ? 
              <></>
              :
              <>
                <tr>
                  <td>temperatura mattina</td>
                  <td>{weather.temp.morn}°C</td>
                </tr>
                <tr>
                  <td>temperatura giorno</td>
                  <td>{weather.temp.day}°C</td>
                </tr>
                <tr>
                  <td>temperatura sera</td>
                  <td>{weather.temp.eve}°C</td>
                </tr>
                <tr>
                  <td>temperatura notte</td>
                  <td>{weather.temp.night}°C</td>
                </tr>
                <tr>
                  <td>umidità</td>
                  <td><OpacityRoundedIcon />{weather.humidity}%</td>
                </tr>
                <tr>
                  <td>velocità vento</td>
                  <td><AirRoundedIcon />{weather.wind_speed} m/s</td>
                </tr>
                <tr>
                  <td>direzione vento</td>
                  <td><AirRoundedIcon />{weather.wind_deg}°</td>
                </tr>
                <tr>
                  <td>nuvole</td>
                  <td><WbCloudyRoundedIcon />{weather.clouds}%</td>
                </tr>
                <tr>
                  <td>probabilità pioggia</td>
                  <td><GrainRoundedIcon />{weather.pop * 100}%</td>
                </tr>
                <tr>
                  {
                    weather.rain ? 
                      <>
                        <td>
                          pioggia
                        </td>
                        <td>
                          <GrainRoundedIcon />{weather.rain} mm
                        </td>
                      </>
                      :
                      <></>
                  }
                </tr>
                <tr>
                  {
                    weather.snow ? 
                      <>
                        <td>
                          neve
                        </td>
                        <td>
                          <AcUnitRoundedIcon />{weather.snow} mm
                        </td>
                      </>
                      :
                      <></>
                  }
                </tr>
              </>
          }
        </tbody>
      </table>
    </div>
  )
}

function getTimeHours(utc) {
  let date = new Date(utc * 1000)
  return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0')
}